import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  OnDestroy
} from '@angular/core';

@Directive({
  selector: '[appFocusTrap]'
})
export class FocusTrapDirective implements AfterViewInit, OnDestroy {
  private focusableElements: HTMLElement[] = [];
  private previouslyFocusedElement: HTMLElement | null = null;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit() {
    // Salva l’elemento che aveva il focus prima dell’apertura
    this.previouslyFocusedElement = document.activeElement as HTMLElement;

    // Trova tutti gli elementi focusabili dentro la modale
    this.focusableElements = Array.from(
      this.el.nativeElement.querySelectorAll<HTMLElement>(
        'a[href], area[href], input:not([disabled]), select:not([disabled]), ' +
          'textarea:not([disabled]), button:not([disabled]), iframe, object, embed, ' +
          '[tabindex]:not([tabindex="-1"]), [contenteditable]'
      )
    ).filter(el => el.offsetParent !== null); // solo visibili

    // Porta il focus sul primo elemento focusabile
    if (this.focusableElements.length) {
      console.log(this.focusableElements, 'focusable el')
      this.focusableElements[0].focus();
    } else {
      // Se non c’è nulla di focusabile, metti il focus sulla modale stessa
      this.el.nativeElement.focus();
    }
  }

  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    // if (event.key !== 'Tab') return;

    // const first = this.focusableElements[0];
    // const last = this.focusableElements[this.focusableElements.length - 1];

    // if (event.shiftKey) {
    //   // SHIFT + TAB → vai indietro
    //   if (document.activeElement === first) {
    //     event.preventDefault();
    //     last.focus();
    //   }
    // } else {
    //   // TAB normale → vai avanti
    //   if (document.activeElement === last) {
    //     event.preventDefault();
    //     first.focus();
    //   }
    // }
  }

  ngOnDestroy() {
    // Ripristina il focus all’elemento precedente
    if (this.previouslyFocusedElement) {
      this.previouslyFocusedElement.focus();
    }
  }
}
